const DEFAULT_ORDER_BASE_NUMBER = 100;

export const getCloudPosOrderNumber = (
	orderBaseNumber: number = DEFAULT_ORDER_BASE_NUMBER,
	paymentNumber: number,
) => {
	const cloudPosOrderNumber = Number(orderBaseNumber) + paymentNumber;
	return cloudPosOrderNumber.toString();
};
